module.exports = __webpack_public_path__ + "img/dole.c95386a4.jpg";